








import React from "react";
import "../../styles/Home.css";
import aboutIcon from "../../assets/about-icon.png";
import sailingIcon from "../../assets/sailing-icon.png";
import serviceIcon from "../../assets/service-icon.png";
import IndianGraniteExpress from "../../assets/Indian Granite Express.png";
import InlandLogistics from "../../assets/Inland Logistics.png";
import IndianSteelExpress from "../../assets/Indian Steel Express.png";
import Timberline from "../../assets/Timberline.png";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import homeImage from "../../images/home-slider.jpg";

const Home = () => {
  const navigate = useNavigate();

  const featuredServices = [
    {
      title: "Indian Granite Express",
      img: IndianGraniteExpress,
      text: "Cut to specifications for the granite industry, the Indian Granite Express has been a name synonymous...",
      href: "/indian-granite-express",
    },
    {
      title: "Inland Logistics",
      img: InlandLogistics,
      text: "Established to cater to the Indian exporter and importer, Puyvast's Logistics division has several...",
      href: "/inland-logistics",
    },
    {
      title: "Indian Steel Express",
      img: IndianSteelExpress,
      text: "India has emerged to be amongst the largest steel-producing nations in the world, and has also seen a...",
      href: "/indian-steel-express",
    },
    {
      title: "Timberline",
      img: Timberline,
      text: "Established to cater to the Indian importers, Timberline, in a period of a few years, has shipped several...",
      href: "/timberline",
    },
  ];
  
  const additionalServices = [
    { 
      title: "Dry Bulk Carriers", 
      text: "India is a country rich in mineral resources and an abundance of agricultural produce, substantial quantities of which are exported...",
      href: "/dry-bulk-carriers",
    },
    { 
      title: "Indian Project Express",
      text: "Puyvast is one of the few companies who can offer a total package of specialized project transport, which can be adapted to the specific requirements of the client. A diversified.",
      href:"/indian-project-express",
    },
    { 
      title: "Freight Forwarding & Custom Clearance", 
      text: "Our Freight Forwarding & Custom Clearance is led by, highly qualified and experienced personnel's.",
      href:"/freight-forwarding",
    },
    { 
      title: "Locations In India",
      text: "BANGALORE - HEAD OFFICE Puyvast Logistics Pvt. Ltd. PuyVast House  # 6, Harris Road, Benson Town, Bangalore - 560 046.",
      href:"/locations",
    }
  ];

  return (
    <div className="home-container">
      {/* Image Slider */}
      <div className="image-slider">
        <img src={homeImage} alt="Home Slider" />
      </div>

      {/* About Us Section with vertical line styling */}
      <section className="about-us">
        <div className="about-us-container">
          <div className="about-text">
            <div className="vertical-header">
              <img src={aboutIcon} alt="About Us" className="header-icon rotate-on-hover" />
              <div className="vertical-line"></div>
              <h3 className="header-title">ABOUT US</h3>
            </div>
            <div className="about-content">
              <p className="section-text">
                Puyvast Logistics Pvt. Ltd., an associate company of PuyVast Chartering B.V., Netherlands, has over a century
                of experience in the shipping industry.
              </p>
              <a href="/about" className="read-more-btn">
                Read More <span className="arrow">&raquo;</span>
              </a>
            </div>
          </div>

          {/* <div className="sailing-schedule">
            <a
              href="https://www.ecl.net.in/SailingSchedule/WestEastBound.aspx"
              target="_blank"
              rel="noopener noreferrer"
              className="sailing-link"
              title="Check Sailing Schedule"
            >
              <img src={sailingIcon} alt="Sailing Schedule" className="sailing-icon" />
            </a>
          </div> */}
        </div>
      </section>

      {/* Services Section with vertical line styling */}
      <section className="services-section">
        {/* Services heading with vertical line style */}
        <div className="vertical-header">
          <img src={serviceIcon} alt="Services" className="header-icon rotate-on-hover" />
          <div className="vertical-line"></div>
          <h2 className="header-title">OUR SERVICES</h2>
        </div>
        
        {/* First row - Cards with Images */}
        <div className="services services-with-images">
          {featuredServices.map((service, index) => (
            <div key={index} className="service-card">
              <div className="blue-service-header">
                <img src={serviceIcon} alt="Service Icon" className="service-icon rotate-on-hover" />
                <h3 className="blue-service-title">{service.title}</h3>
              </div>
              <div className="service-image-container">
                <img src={service.img} alt={service.title} className="service-image" />
              </div>
              <p className="service-description">{service.text}</p>
              <button onClick={() => navigate(service.href)} className="read-more-btn service-btn">
                Read More
              </button>
            </div>
          ))}
        </div>

        {/* Second row - Cards Without Images */}
        <div className="services services-without-images">
          {additionalServices.map((service, index) => (
            <div key={index} className="service-card">
              <div className="blue-service-header">
                <img src={serviceIcon} alt="Service Icon" className="service-icon rotate-on-hover" />
                <h3 className="blue-service-title">{service.title}</h3>
              </div>
              <p className={`service-description ${service.title === "Locations In India" ? "location-text" : ""}`}>
                {service.text}
              </p>
              <button onClick={() => navigate(service.href)} className="read-more-btn service-btn">
                Read More
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6 Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
